import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { useIntl } from 'react-intl';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MessageTimeStats = ({ className = '' }) => {
	const { formatMessage } = useIntl();

	const labels = ['01/01', '02/02', '03/03', '04/04', '05/05', '06/06', '07/07', '08/08', '09/09', '10/10', '11/11', '12/12'];
	const data = [6800, 4000, 5900, 4000, 5000, 6800, 5400, 3700, 4800, 6800, 4300, 4900];

	const chartData = {
		labels,
		datasets: [
			{
				label: 'Messages',
				data,
				backgroundColor: '#50B553',
				borderRadius: 2,
				borderSkipped: false,
				maxBarThickness: 30
			}
		]
	};

	const options = {
		responsive: true,
		maintainAspectRatio: false,
		resizeDelay: 200,
		plugins: {
			legend: { display: false }
		},
		transitions: {
			resize: {
				animation: {
					duration: 800,
					easing: 'easeOutCubic'
				}
			}
		},
		scales: {
			x: {
				grid: { display: false },
				ticks: { color: '#718096', font: { size: 12 } }
			},
			y: {
				beginAtZero: true,
				suggestedMax: 7000,
				grid: { color: '#EAEAEA', borderDash: [4, 4], drawBorder: false },
				title: { display: true, text: formatMessage({ id: 'DASHBOARD.TIME_STATS.Y_AXIS' }), color: '#50B553', font: { size: 12 } },
				ticks: {
					stepSize: 1000,
					color: '#7C7C7C',
					font: { size: 12 },
					callback: value => (value >= 1000 ? `${value / 1000}k` : value)
				}
			}
		}
	};

	return (
		<div className={`border p-5 pt-6 rounded-lg shadow-lg h-full flex flex-col ${className}`}>
			<p className='text-lg font-medium pb-3'>
				{formatMessage({ id: 'DASHBOARD.TIME_STATS.TITLE' })}
			</p>
			<div className="flex-1 min-h-0" style={{ height: '100%' }}>
				<Bar options={options} data={chartData} height={undefined} width={undefined} />
			</div>
		</div>
	);
};

export { MessageTimeStats };


